import React from 'react';

const LIVE_COLOR = '#3BADAE';
const OFFLINE_COLOR = '#9aa3ab';

/**
 * Live / Offline indicator. `isLive` is driven by the parent’s /getheartbeat poll.
 * Pass `null` while the first check is in flight.
 */
export default function MonitorHeartbeatStatus({ isLive = null }) {
    if (isLive === null) {
        return (
            <div
                className="monitor-heartbeat-status"
                aria-label="Checking connection status"
                aria-live="polite"
            >
                <span
                    className="monitor-heartbeat-status__dot monitor-heartbeat-status__dot--pending"
                    aria-hidden
                />
                <span className="monitor-heartbeat-status__label monitor-heartbeat-status__label--pending">
                    …
                </span>
            </div>
        );
    }

    const color = isLive ? LIVE_COLOR : OFFLINE_COLOR;
    const label = isLive ? 'Live' : 'Offline';

    return (
        <div
            className={`monitor-heartbeat-status${isLive ? ' monitor-heartbeat-status--live' : ' monitor-heartbeat-status--offline'}`}
            aria-label={`Connection status: ${label}`}
            aria-live="polite"
        >
            <span
                className={`monitor-heartbeat-status__dot${isLive ? ' monitor-heartbeat-status__dot--live' : ' monitor-heartbeat-status__dot--offline'}`}
                style={{ backgroundColor: color }}
                aria-hidden
            />
            <span className="monitor-heartbeat-status__label" style={{ color }}>
                {label}
            </span>
        </div>
    );
}
